module.exports = __webpack_public_path__ + "static/media/(V)_MG_5441_-_Pro-Natura_-_Moda_Masculina_Infantil.7c52b171.jpg";